export const INITIAL_PLAN = "start_your_business";
export const SUBSCRIPTION_CHECK_ATTEMPTS_TIMEOUT = 10000;
export const MAX_SUBSCRIPTION_CHECK_ATTEMPTS = 60;
export const ON_SUCCESS_OR_FAILURE_DELAY = 500;
